export default [{
  name: 'fullMap',
  path: '/fullMap',
  component: () => import('./FullMap.vue')
}]



// WEBPACK FOOTER //
// ./src/router/fullmap/index.js